import { notifyTokenExpired } from '../../../auth/services/tokenExpired';

export const TOKEN_ERROR_TEXT = 'Access token expired or corrupted';
export const TECHNICAL_ERROR_TEXT = 'Technical error occurred, please reload the page later';
export const NOT_FOUND_TEXT = 'Book not found';

/**
 * Routes the editor away after the book failed to load.
 *
 * Guests must never land on 404: the client router clears the guest session
 * on any route outside /embed/ and /error.
 */
export function handleBookLoadError(err, { isGuestAccess, router }) {
    const status = err?.status ?? err?.response?.status;
    const go = (location) => router.replace(location).catch(() => {});

    if (!isGuestAccess) {
        return go({ name: '404' });
    }

    if (status === 404) {
        return go({ name: 'error', params: { text: NOT_FOUND_TEXT } });
    }

    if (status === 401 || status === 403) {
        // The book itself is not readable, so the token is useless (e.g. issued
        // with empty actions). Ask Platform for a new link (throttled per book).
        notifyTokenExpired();
        return go({ name: 'error', params: { text: TOKEN_ERROR_TEXT } });
    }

    // 5xx, network error or anything unexpected: keep the session, let the user retry
    return go({ name: 'error', params: { text: TECHNICAL_ERROR_TEXT } });
}
